export interface IEnvironmentConfig {
    environment: 'Prod' | 'Non-Prod';
    baseUrl: string;
}

/**
 * Get environment configuration based on hostname
 * @param hostname - The hostname to check (defaults to window.location.hostname)
 * @returns Environment configuration object with environment and baseUrl
 */
export const getEnvConfig = (
    hostname: string = typeof window !== 'undefined' ? window.location.hostname : '',
): IEnvironmentConfig => {
    switch (hostname) {
        case 'www.carmax.com':
            return {
                environment: 'Prod',
                baseUrl: 'https://www.carmax.com',
            };
        case 'wwwqa.carmax.com':
            return {
                environment: 'Non-Prod',
                baseUrl: 'https://wwwqa.carmax.com',
            };
        case 'home-website-dev.carmax.com':
            return {
                environment: 'Non-Prod',
                baseUrl: 'https://home-website-dev.carmax.com',
            };
        default:
            return {
                environment: 'Non-Prod',
                baseUrl: 'https://home-website-local.carmax.com',
            };
    }
};
